import { render, staticRenderFns } from "./KeyComponentEdit.vue?vue&type=template&id=4f4fe15a&scoped=true"
import script from "./KeyComponentEdit.vue?vue&type=script&lang=js"
export * from "./KeyComponentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4fe15a",
  null
  
)

export default component.exports